import AsyncLayoutFactory from '@/Factories/AsyncLayoutFactory';
import ComponentManager from '@/Management/ComponentManager';
import LayoutRenderer from '@/Utility/LayoutRenderer';

export default class TwoColumnLayoutFactory extends AsyncLayoutFactory {

    private jQueryControl: JQuery;
    private LayoutRenderer = ComponentManager.getUtility<typeof LayoutRenderer>('LayoutRenderer');

    public async getElementAsync(): Promise<JQuery> {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }
        this.jQueryControl = await new Promise<JQuery>((resolve) => {
            window.setTimeout(() => {
                if (this.isDisposed)
                    return;

                const $layout = this.LayoutRenderer.renderTwoColumnLayout(this.tuples, this.context.labelColumnWidth);
                resolve($layout);
            });
        });
        return this.jQueryControl;
    }
    
    protected disposeInternal() : void {
        this.LayoutRenderer.disposeTwoColumnLayout(this.jQueryControl);
        super.disposeInternal();
    }
}

ComponentManager.setFactory('TwoColumnLayout', TwoColumnLayoutFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');